<template>
  <b-row>
    <b-col :sm="12" class="my-2">
      <button class="btn btn-outline-primary mr-1" variant="'outline-primary'" :class="{current: selectedReasonType === 'lgbt'}" @click="selectedReasonType = 'lgbt'">
        Demande LGBTQIA+
      </button>
      <button class="btn btn-outline-primary mr-1" variant="'outline-primary'" :class="{current: selectedReasonType === 'other'}" @click="selectedReasonType = 'other'">
        Autres demandes
      </button>
      <button class="btn btn-outline-primary mr-1" variant="'outline-primary'" :class="{current: selectedReasonType === 'hebergement'}" @click="selectedReasonType = 'hebergement'">
        Demandes d'hébergement
      </button>
    </b-col>
    <b-col v-if="selectedReasonType === 'lgbt'" :md="6">
      <chartjs-container :title="lgbtChartTitle">
        <chartjs-component-horizontal-bar-chart v-if="lgbtChartHasMeaningfulData" key="lgbt-horizontal-bar"
                                                :height="chartHeight" :chart-data="lgbtChartData" />
        <p v-else>
          Aucune information disponible
        </p>
      </chartjs-container>
    </b-col>
    <b-col v-if="selectedReasonType === 'other'" :md="6">
      <chartjs-container :title="otherChartTitle">
        <chartjs-component-horizontal-bar-chart v-if="othersChartHasMeaningfulData" key="other-horizontal-bar"
                                                :height="chartHeight" :chart-data="otherChartData" />
        <p v-else>
          Aucune information disponible
        </p>
      </chartjs-container>

    </b-col>
    <b-col v-if="selectedReasonType === 'hebergement'" :md="6">
      <chartjs-container :title="accommodationByAgeChartTitle">
        <chartjs-component-horizontal-bar-chart v-if="accommodationByAgeChartData" key="accommodation-horizontal-bar"
                                                :height="chartHeight" :chart-data="accommodationByAgeChartData" />
        <p v-else>
          Aucune information disponible
        </p>
      </chartjs-container>
    </b-col>
    <b-col v-if="selectedReasonType === 'lgbt'" :md="6">
      <chartjs-container :title="lgbtChartTitlePie">
        <chartjs-component-pie-chart v-if="lgbtChartHasMeaningfulData" key="lgbt-pie"
                                     :height="chartHeight" :chart-data="lgbtPieChartData" />
        <p v-else>
          Aucune information disponible
        </p>
      </chartjs-container>
    </b-col>

    <b-col v-if="selectedReasonType === 'hebergement'" :md="6">
      <chartjs-container :title="accommodationByAgePieChartTitle">
        <chartjs-component-pie-chart v-if="accommodationByAgePieChartData" key="accommodation-age-pie"
                                     :height="chartHeight" :chart-data="accommodationByAgePieChartData" />
        <p v-else>
          Aucune information disponible
        </p>
      </chartjs-container>
    </b-col>

    <b-col v-if="selectedReasonType === 'hebergement'" :md="6">
      <chartjs-container :title="accommodation18_25ByRegionsChartTitle">
        <chartjs-component-pie-chart v-if="accommodation18_25ByRegionsPieChartData" key="accommodation-regions-pie"
                                     :height="chartHeight" :chart-data="accommodation18_25ByRegionsPieChartData" />
        <p v-else>
          Aucune information disponible
        </p>
      </chartjs-container>
    </b-col>

    <b-col v-if="selectedReasonType === 'other'" :md="6">
      <chartjs-container :title="otherChartTitlePie">
        <chartjs-component-pie-chart v-if="othersChartHasMeaningfulData" key="other-pie"
                                     :height="chartHeight" :chart-data="otherPieChartData" />
        <p v-else>
          Aucune information disponible
        </p>
      </chartjs-container>
    </b-col>

    <b-col v-if="selectedReasonType === 'lgbt'" :md="6">
      <chartjs-container :title="lgbtChartTitleBar">
        <chartjs-component-bar-chart v-if="lgbtChartHasMeaningfulData" key="lgbt-bar"
                                     :height="chartHeight" :chart-data="lgbtBarChartData" />
        <p v-else>
          Aucune information disponible
        </p>
      </chartjs-container>
    </b-col>

    <b-col v-if="selectedReasonType === 'other'" :md="6">
      <chartjs-container :title="otherChartTitleBar">
        <chartjs-component-bar-chart v-if="othersChartHasMeaningfulData" key="other-bar"
                                     :height="chartHeight" :chart-data="otherBarChartData" />
        <p v-else>
          Aucune information disponible
        </p>
      </chartjs-container>
    </b-col>

  </b-row>
</template>

<script>

import {
  BCol,
  BRow,
} from 'bootstrap-vue'
import ChartjsContainer from '../ChartjsContainer.vue'
import ChartjsComponentHorizontalBarChart from '../charts-components/ChartjsComponentHorizontalBarChart.vue'
import useStatisticsRouteFetch from '../useStatisticsRouteFetch'
import {
  computedConfiguration,
  watchConfiguration,
  BASE_CHART_HEIGHT,
  chartHasMeaningfulData,
  CHART_COLORS,
  TABS,
} from './baseConfiguration'
import ChartjsComponentPieChart from '../charts-components/ChartjsComponentPieChart.vue'
import ChartjsComponentBarChart from '../charts-components/ChartjsComponentBarChart.vue'

export default {
  components: {
    BCol,
    BRow,
    ChartjsContainer,
    ChartjsComponentHorizontalBarChart,
    ChartjsComponentPieChart,
    ChartjsComponentBarChart,
  },
  data() {
    return {
      tabname: TABS.DEMANDREASON,
      lgbtChartTitle: 'Demandes LGBTQIA+',
      lgbtChartTitlePie: 'Demandes LGBTQIA+ ',
      lgbtChartTitleBar: 'Demandes LGBTQIA+ ',
      otherChartTitle: 'Autres demandes',
      otherChartTitlePie: 'Autres demandes ',
      otherChartTitleBar: 'Autres demandes ',
      accommodationByAgeChartTitle: 'Répartition par tranche d\'âge',
      accommodationByAgePieChartTitle: 'Répartition par tranche d\'âge ',
      accommodation18_25ByRegionsChartTitle: 'Répartition par régions / 18-25 ans',

      lgbtChartData: {},
      otherChartData: {},
      accommodationByAgeChartData: {},
      lgbtPieChartData: {},
      otherPieChartData: {},
      accommodationByAgePieChartData: {},
      accommodation18_25ByRegionsPieChartData: {},
      lgbtBarChartData: {},
      otherBarChartData: {},
      chartHeight: BASE_CHART_HEIGHT,
      selectedReasonType: 'lgbt',
    }
  },
  computed: {
    lgbtChartHasMeaningfulData() {
      return chartHasMeaningfulData(this.lgbtChartData)
    },
    othersChartHasMeaningfulData() {
      return chartHasMeaningfulData(this.otherChartData)
    },
    accommodationByAgeChartHasMeaningfulData() {
      return chartHasMeaningfulData(this.accommodationByAge)
    },

     accommodation18_25ByRegionsChartHasMeaningfulData() {
      return chartHasMeaningfulData(this.accommodation18_25ByRegions)
    },

    ...computedConfiguration,
  },
  watch: watchConfiguration,
  methods: {
    fetchRouteOnActive() {
      if (this.active) {
        this.fetchRoute()
      }
    },
    async fetchRoute() {
      const response = await useStatisticsRouteFetch()
      this.lgbtChartData = this.buildChartData(response.lgbtqia_Plus)
      this.otherChartData = this.buildChartData(response.others)
      this.accommodationByAgeChartData = this.buildChartData(response.accommodationByAge)

      this.lgbtPieChartData = this.buildPieChartData(response.lgbtqia_Plus)
      this.otherPieChartData = this.buildPieChartData(response.others)
      this.accommodationByAgePieChartData = this.buildPieChartData(response.accommodationByAge)
      this.accommodation18_25ByRegionsPieChartData = this.buildPieChartData(response.accommodation18_25ByRegions)
      this.lgbtBarChartData = this.constructBarChart(response.lgbtqia_Plus)
      this.otherBarChartData = this.constructBarChart(response.others)
    },
    buildChartData(data) {
      const formattedLabels = this.formatLabels(data)
      const formattedData = this.formatValues(data)
      return {
        labels: formattedLabels,
        datasets: [{
          label: 'Nombre de demandes',
          data: formattedData,
          backgroundColor: CHART_COLORS.BRAND.PRIMARY_LIGHT,
          barThickness: 20,
        }],
      }
    },
    buildPieChartData(data) {
      const labels = this.formatLabels(data)
      const values = this.formatValues(data)
      return {
        labels,
        datasets: [
          {
          data: values,
          backgroundColor: CHART_COLORS.PRIMARY,
         },
      ],
      }
    },

    constructBarChart(data) {
      const labels = this.formatBarLabels(data)
      const datasets = this.formatBarData(data)
      return { labels, datasets }
     },
    formatBarLabels(data) {
      return Object.keys(data).map((key => data[key].label))
    },
    formatBarData(data) {
      return [
        {
          label: 'Demandes LGBTQIA+',
          data: Object.keys(data).map((key => data[key].value)),
          backgroundColor: CHART_COLORS.PRIMARY,
          barThickness: 20,
        },
      ]
    },

    formatLabels(data) {
      return Object.keys(data).map((key => data[key].label))
    },
    formatValues(data) {
      return Object.keys(data).map((key => data[key].value))
    },
  },
}

</script>

<style>
.current {
  background-color: rgba(22, 181, 234, 0.2);
  color: #16B5EA;
}
</style>
